import { render } from "./ShareJourly.vue?vue&type=template&id=1fd7db22&scoped=true"
import script from "./ShareJourly.vue?vue&type=script&lang=js"
export * from "./ShareJourly.vue?vue&type=script&lang=js"

import "./ShareJourly.vue?vue&type=style&index=0&id=1fd7db22&scoped=true&lang=css"

import exportComponent from "/Users/ratul/Code/vue/jourly-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd7db22"]])

export default __exports__